import React from 'react';
import TruncatedTooltip from './TruncatedTooltip';

const BrandCell = ({ item, getMaxLength, isOrderScreen, isTemplateScreen }) => {
  // Extract the brand string safely
  const brand =
    item?.brand && item?.brand !== ''
      ? typeof item?.brand === 'string'
        ? item.brand
        : item?.brand[0]
      : '';

  // Only render if brand exists
  if (!brand) return null;

  return (
    <TruncatedTooltip
      text={brand}
      maxLength={getMaxLength('brand')}
      productCfn={item.productCFN || item.cfn || item.bom}
      isOrderScreen={isOrderScreen}
      isTemplateScreen={isTemplateScreen}
      isBrand={true}
    />
  );
};

export default BrandCell;